import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
// import "./DisplayBiblicalPlaces.css";

const DisplayBiblicalPlaces = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [places, setPlaces] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [openDetails, setOpenDetails] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [selectedPlace, setSelectedPlace] = useState(null);
  const [formData, setFormData] = useState({});

  // ================= SEARCH =================
  const [search, setSearch] = useState("");



  // ================= FETCH ALL PLACES =================
  useEffect(() => {
    fetchPlaces();
  }, []);



  const fetchPlaces = async () => {
    try {
      // Backend does not have list all places,
      // so we load categories then places by category

      const categoryResponse = await fetch(
        `${API_URL}/bible/places/categories`
      );

      const categoryResult =
        await categoryResponse.json();


      let allPlaces = [];


      for (const category of categoryResult.data || []) {

        const response = await fetch(
          `${API_URL}/bible/places/category/${category.id}`
        );

        const result =
          await response.json();


        allPlaces = [
          ...allPlaces,
          ...(result.data || [])
        ];

      }


      setPlaces(allPlaces);


    } catch (error) {

      console.error(
        "Error fetching places:",
        error
      );

    }
  };




  // ================= SEARCH =================

  const handleSearch = async (value) => {

    setSearch(value);


    if (!value) {

      fetchPlaces();

      return;
    }



    try {

      const response = await fetch(
        `${API_URL}/bible/places/search?q=${value}`
      );


      const result =
        await response.json();


      setPlaces(
        result.data || []
      );


    } catch (error) {

      console.error(
        "Search error:",
        error
      );

    }

  };





  // ================= PAGINATION =================


  const handlePageChange = (
    event,
    newPage
  ) => {

    setPage(newPage);

  };



  const handleRowsPerPageChange = (
    event
  ) => {

    setRowsPerPage(
      parseInt(
        event.target.value,
        10
      )
    );

    setPage(0);

  };





  // ================= OPEN DIALOGS =================


  const handleOpenDetails = (
    place
  ) => {

    setSelectedPlace(place);

    setOpenDetails(true);

  };



  const handleOpenEdit = (
    place
  ) => {

    setSelectedPlace(place);

    setFormData(place);

    setOpenEdit(true);

  };



  const handleOpenDelete = (
    place
  ) => {

    setSelectedPlace(place);

    setOpenDelete(true);

  };



  const handleCloseDialogs = () => {

    setOpenDetails(false);

    setOpenEdit(false);

    setOpenDelete(false);

    setSelectedPlace(null);

    setFormData({});

  };






  // ================= INPUT CHANGE =================


  const handleInputChange = (
    e
  ) => {

    setFormData({
      ...formData,
      [e.target.name]:
        e.target.value,
    });

  };







  // ================= UPDATE PLACE =================


  const handleUpdate = async () => {

    try {


      const response =
        await fetch(
          `${API_URL}/bible/places/${selectedPlace.id}`,
          {
            method:"PUT",
            headers:{
              "Content-Type":
                "application/json",
            },
            body:
              JSON.stringify(formData),
          }
        );


      const result =
        await response.json();



      if(response.ok){

        fetchPlaces();

      }else{

        console.error(
          result.message
        );

      }



    } catch(error){

      console.error(
        "Update error:",
        error
      );


    } finally {

      handleCloseDialogs();

    }

  };






  // ================= DELETE PLACE =================


  const handleDelete = async () => {

    try {


      const response =
        await fetch(
          `${API_URL}/bible/places/${selectedPlace.id}`,
          {
            method:"DELETE",
          }
        );



      if(response.ok){

        setPlaces((prev)=>
          prev.filter(
            (p)=>
              p.id !== selectedPlace.id
          )
        );

      }



    } catch(error){

      console.error(
        "Delete error:",
        error
      );


    } finally {

      handleCloseDialogs();

    }

  };






  return (
    <>


      {/* ================= SEARCH ================= */}

      <div className="search-box">

        <TextField
          fullWidth
          label="Search biblical places..."
          value={search}
          onChange={(e)=>
            handleSearch(
              e.target.value
            )
          }
          sx={{mb:2}}
        />

      </div>





      {/* ================= TABLE ================= */}


      <TableContainer component={Paper}>


        <Table>


          <TableHead>

            <TableRow>

              <TableCell>ID</TableCell>

              <TableCell>Name</TableCell>

              <TableCell>Name Am</TableCell>
          

              <TableCell>Country</TableCell>

              <TableCell>Modern Name</TableCell>

              <TableCell>Actions</TableCell>


            </TableRow>


          </TableHead>



          <TableBody>


          {places
          .slice(
            page * rowsPerPage,
            page * rowsPerPage +
              rowsPerPage
          )
          .map((place)=>(


            <TableRow
              key={place.id}
            >


              <TableCell>
                {place.id}
              </TableCell>


              <TableCell>
                {place.name}
              </TableCell>


              <TableCell>
                {place.nameAm}
              </TableCell>

              <TableCell>
                {place.currentCountry}
              </TableCell>


              <TableCell>
                {place.modernName}
              </TableCell>



              <TableCell
                sx={{
                  display:"flex",
                  flexDirection:"column",
                  gap:1,
                }}
              >


                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={()=>
                    handleOpenEdit(place)
                  }
                >
                  Edit
                </Button>



                <Button
                  variant="contained"
                  size="small"
                  color="error"
                  onClick={()=>
                    handleOpenDelete(place)
                  }
                >
                  Delete
                </Button>



                <Button
                  variant="outlined"
                  size="small"
                  color="info"
                  onClick={()=>
                    handleOpenDetails(place)
                  }
                >
                  View
                </Button>



              </TableCell>



            </TableRow>


          ))}


          </TableBody>


        </Table>




        <TablePagination

          rowsPerPageOptions={[
            5,
            10,
            25
          ]}

          component="div"

          count={
            places.length
          }

          rowsPerPage={
            rowsPerPage
          }

          page={
            page
          }

          onPageChange={
            handlePageChange
          }

          onRowsPerPageChange={
            handleRowsPerPageChange
          }

        />



      </TableContainer>







      {/* ================= DETAILS ================= */}


      <Dialog
        open={openDetails}
        onClose={
          handleCloseDialogs
        }
      >

        <DialogTitle>
          Biblical Place Details
        </DialogTitle>


        <DialogContent>


          <Typography>
            <b>ID:</b>
            {selectedPlace?.id}
          </Typography>


          <Typography>
            <b>Name:</b>
            {selectedPlace?.name}
          </Typography>


          <Typography>
            <b>Name Am:</b>
            {selectedPlace?.nameAm}
          </Typography>


          <Typography>
            <b>Alternative Names:</b>
            {selectedPlace?.alternativeNames}
          </Typography>


          <Typography>
            <b>Original Name:</b>
            {selectedPlace?.originalName}
          </Typography>


          <Typography>
            <b>Modern Name:</b>
            {selectedPlace?.modernName}
          </Typography>


          <Typography>
            <b>Country:</b>
            {selectedPlace?.currentCountry}
          </Typography>


          <Typography>
            <b>Latitude:</b>
            {selectedPlace?.latitude}
          </Typography>


          <Typography>
            <b>Longitude:</b>
            {selectedPlace?.longitude}
          </Typography>


        </DialogContent>


        <DialogActions>

          <Button
            onClick={
              handleCloseDialogs
            }
          >
            Close
          </Button>

        </DialogActions>


      </Dialog>









      {/* ================= EDIT ================= */}


      <Dialog
        open={openEdit}
        onClose={
          handleCloseDialogs
        }
      >


        <DialogTitle>
          Edit Biblical Place
        </DialogTitle>


        <DialogContent>



          <TextField

            label="Name"

            name="name"

            value={
              formData.name || ""
            }

            onChange={
              handleInputChange
            }

            fullWidth

            margin="dense"

          />



          <TextField

            label="Name Am"

            name="nameAm"

            value={
              formData.nameAm || ""
            }

            onChange={
              handleInputChange
            }

            fullWidth

            margin="dense"

          />



          <TextField

            label="Modern Name"

            name="modernName"

            value={
              formData.modernName || ""
            }

            onChange={
              handleInputChange
            }

            fullWidth

            margin="dense"

          />



          <TextField

            label="Current Country"

            name="currentCountry"

            value={
              formData.currentCountry || ""
            }

            onChange={
              handleInputChange
            }

            fullWidth

            margin="dense"

          />



          <TextField

            label="Latitude"

            name="latitude"

            value={
              formData.latitude || ""
            }

            onChange={
              handleInputChange
            }

            fullWidth

            margin="dense"

          />



          <TextField

            label="Longitude"

            name="longitude"

            value={
              formData.longitude || ""
            }

            onChange={
              handleInputChange
            }

            fullWidth

            margin="dense"

          />


        </DialogContent>



        <DialogActions>


          <Button
            onClick={
              handleCloseDialogs
            }
            color="secondary"
          >
            Cancel
          </Button>



          <Button
            onClick={
              handleUpdate
            }
            color="primary"
          >
            Save
          </Button>


        </DialogActions>


      </Dialog>









      {/* ================= DELETE ================= */}


      <Dialog
        open={openDelete}
        onClose={
          handleCloseDialogs
        }
      >


        <DialogTitle>
          Delete Biblical Place
        </DialogTitle>



        <DialogContent>


          Are you sure you want to delete{" "}


          <b>
            {selectedPlace?.name}
          </b>


          ?


        </DialogContent>



        <DialogActions>



          <Button
            onClick={
              handleCloseDialogs
            }
          >
            Cancel
          </Button>



          <Button
            onClick={
              handleDelete
            }
            color="error"
          >
            Delete
          </Button>



        </DialogActions>



      </Dialog>



    </>
  );
};


export default DisplayBiblicalPlaces;